<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="`0 0 46 46`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.14544 18.5174C2.79604 18.4532 3.9934 17.0934 4.42211 15.4052C4.85082 13.7171 4.48243 12.6533 3.67888 12.8877C2.87532 13.1221 2.27211 14.6185 1.93733 16.0864C1.60255 17.5544 1.49484 18.5816 2.14544 18.5174Z"
      :fill="props.fill"
    />
    <path
      d="M3.15506 23.073C3.15506 21.2725 2.33039 19.9187 1.71684 20.0639C1.10329 20.2091 0.984375 21.5659 0.984375 23.073C0.984375 24.5802 1.10631 25.9353 1.71684 26.0822C2.32737 26.2291 3.15506 24.8758 3.15506 23.073Z"
      :fill="props.fill"
    />
    <path
      d="M4.42052 30.7542C3.99354 29.0661 2.79273 27.7123 2.14385 27.6421C1.49497 27.5718 1.60096 28.5981 1.93574 30.0756C2.27052 31.553 2.87588 33.0403 3.67729 33.2739C4.47869 33.5074 4.8488 32.4423 4.42052 30.7542Z"
      :fill="props.fill"
    />
    <path
      d="M45.3973 18.5113C46.0462 18.5832 45.9402 17.547 45.6054 16.0799C45.2707 14.6128 44.6666 13.1152 43.8652 12.8816C43.0638 12.6481 42.695 13.7128 43.122 15.4009C43.5489 17.089 44.7498 18.441 45.3986 18.513"
      :fill="props.fill"
    />
    <path
      d="M45.8269 20.0637C45.2146 19.9167 44.3887 21.2701 44.3887 23.0728C44.3887 24.8755 45.2133 26.2271 45.8269 26.0819C46.4404 25.9367 46.5594 24.58 46.5594 23.0728C46.5594 21.5656 46.4396 20.2106 45.8269 20.0637Z"
      :fill="props.fill"
    />
    <path
      d="M45.3992 27.6386C44.7486 27.7045 43.553 29.0604 43.1226 30.7507C42.6921 32.441 43.064 33.5043 43.8658 33.2699C44.6676 33.0355 45.2713 31.5392 45.6061 30.0712C45.9408 28.6033 46.0486 27.5722 45.3979 27.6399"
      :fill="props.fill"
    />
    <path
      d="M9.80654 9.60354C11.343 9.24162 12.574 8.09466 13.0436 6.58751H13.0376C13.3133 5.27424 12.3559 4.62709 10.9548 4.90715C9.51786 5.20961 8.35582 6.26393 7.91505 7.66466C7.59751 8.965 8.36056 9.87412 9.80654 9.60354Z"
      :fill="props.fill"
    />
    <path
      d="M8.32847 17.7559C9.97523 17.3746 11.1536 15.9256 11.1911 14.2358C11.2898 12.4438 10.1907 11.3223 8.78949 11.5756C7.23667 11.9509 6.12763 13.3193 6.08153 14.9161C6.01518 16.5887 6.9243 17.8753 8.32761 17.7546"
      :fill="props.fill"
    />
    <path
      d="M5.35742 24.5251C5.73313 26.071 7.29112 27.0193 8.83706 26.6436L8.86679 26.6363C10.4196 26.2201 11.3473 24.6306 10.9453 23.0739C11.0655 22.5974 11.0655 22.098 10.9453 21.6215C10.5691 20.0756 9.0107 19.1268 7.46476 19.5034L7.4359 19.5103C5.88307 19.9265 4.95542 21.5159 5.35742 23.0726C5.23678 23.5496 5.23678 24.0481 5.35742 24.5251Z"
      :fill="props.fill"
    />
    <path
      d="M8.3269 28.399C6.92402 28.2783 6.02222 29.5623 6.08082 31.2375C6.12692 32.8343 7.23596 34.2027 8.78879 34.578C10.1917 34.8287 11.2878 33.7068 11.1904 31.9183C11.1529 30.2284 9.97452 28.7794 8.32776 28.3981"
      :fill="props.fill"
    />
    <path
      d="M13.0502 39.5619C12.581 38.0544 11.35 36.9074 9.81311 36.5459C8.36713 36.2736 7.60408 37.1827 7.92205 38.4848C8.3624 39.886 9.52486 40.9398 10.9618 41.2423C12.3625 41.5224 13.3199 40.8743 13.0441 39.5619H13.0502Z"
      :fill="props.fill"
    />
    <path
      d="M37.7289 9.59863C39.1749 9.87094 39.938 8.96182 39.6204 7.65975C39.1792 6.25687 38.0142 5.20212 36.5747 4.90224C35.1731 4.62218 34.2157 5.26976 34.4919 6.5826C34.9615 8.08975 36.1925 9.23671 37.7289 9.59863Z"
      :fill="props.fill"
    />
    <path
      d="M36.3516 14.2395C36.3895 15.9289 37.5679 17.3779 39.2143 17.7597C40.6167 17.8803 41.5189 16.5942 41.4603 14.922C41.4138 13.3252 40.3048 11.9572 38.7524 11.5815C37.3495 11.3299 36.2534 12.4514 36.3507 14.2417"
      :fill="props.fill"
    />
    <path
      d="M42.1836 21.6197C41.8078 20.0737 40.2498 19.1254 38.7039 19.5011L38.6742 19.5084C37.1214 19.9246 36.1937 21.5141 36.5957 23.0708C36.4755 23.5473 36.4755 24.0467 36.5957 24.5232C36.9714 26.0692 38.529 27.0175 40.0749 26.6418L40.1055 26.6345C41.6583 26.2182 42.5855 24.6288 42.184 23.0725C42.3038 22.5956 42.3033 22.0966 42.1836 21.6197Z"
      :fill="props.fill"
    />
    <path
      d="M38.7553 34.5797C40.3094 34.2019 41.4172 32.8296 41.459 31.2311C41.5253 29.5589 40.6162 28.2723 39.2137 28.3926C37.5665 28.7764 36.389 30.2285 36.3537 31.9196C36.2563 33.7128 37.3541 34.8344 38.7553 34.5797Z"
      :fill="props.fill"
    />
    <path
      d="M36.58 41.2447C38.0169 40.9418 39.1785 39.8879 39.6197 38.4872H39.6258C39.9446 37.1868 39.1815 36.2777 37.7347 36.5483C36.1978 36.9098 34.9669 38.0567 34.4976 39.5643C34.2219 40.8767 35.1784 41.5247 36.58 41.2447Z"
      :fill="props.fill"
    />
    <path
      d="M19.2338 2.70461C20.9572 2.35992 22.2782 1.26683 22.2412 0.640786C22.2041 0.0147431 21.0559 0.0978995 19.5996 0.365465C18.1433 0.63303 16.6697 1.03201 16.447 1.72828C16.2242 2.42455 17.512 3.04887 19.2342 2.70634"
      :fill="props.fill"
    />
    <path
      d="M18.3646 8.58328C20.3534 8.52985 22.0411 7.27389 22.089 5.98604C22.1368 4.69819 20.6938 3.8955 18.8872 3.92049C17.0806 3.94548 15.436 4.8253 15.2046 6.13598C14.9733 7.44666 16.3762 8.63843 18.365 8.585"
      :fill="props.fill"
    />
    <path
      d="M18.0195 17.2959C20.1389 17.239 21.8494 15.5449 21.927 13.4259V13.4212C21.927 13.31 21.9223 13.1993 21.9119 13.0898V13.0868C21.7508 11.2466 20.1281 9.8855 18.2879 10.0466H18.2741C16.2569 10.0837 14.5993 11.6495 14.4472 13.6611C14.4408 13.7766 14.4408 13.893 14.4472 14.0084V14.0119C14.5261 15.9033 16.1233 17.373 18.0148 17.2942H18.0234"
      :fill="props.fill"
    />
    <path
      d="M17.9674 26.8949C20.1028 26.9194 21.8534 25.2081 21.8779 23.0727V23.0374C21.8917 20.877 20.1515 19.1144 17.9911 19.1006C15.8386 19.1618 14.1435 20.9563 14.2047 23.1089C14.2633 25.1663 15.9105 26.8242 17.9674 26.8949Z"
      :fill="props.fill"
    />
    <path
      d="M18.2744 36.1085C18.3825 36.1214 18.4919 36.1266 18.601 36.124C20.4554 36.1068 21.9444 34.5901 21.9276 32.7357H21.9324C21.8548 30.6167 20.1447 28.9221 18.0249 28.8644C17.9116 28.8584 17.7974 28.8584 17.6841 28.8644H17.6815C15.787 28.976 14.3397 30.5999 14.447 32.4948C14.5995 34.5065 16.2571 36.0714 18.2744 36.1085Z"
      :fill="props.fill"
    />
    <path
      d="M22.0911 40.1655C22.042 38.8789 20.3569 37.6234 18.3667 37.5682C16.3766 37.5131 14.9801 38.704 15.2055 40.0173C15.4308 41.3305 17.0737 42.2043 18.8876 42.2328C20.7016 42.2612 22.1372 41.4572 22.0894 40.1672"
      :fill="props.fill"
    />
    <path
      d="M22.2417 45.5117C22.2788 44.8904 20.9578 43.7843 19.2343 43.4478C17.5109 43.1113 16.2239 43.7309 16.4471 44.4259C16.6702 45.1209 18.1382 45.5272 19.5993 45.7887C21.0603 46.0502 22.203 46.139 22.2417 45.5134"
      :fill="props.fill"
    />
    <path
      d="M28.3075 2.70484C30.031 3.04006 31.3149 2.42177 31.0948 1.72679C30.8746 1.03181 29.4054 0.626797 27.9422 0.363971C26.4789 0.101146 25.3372 0.0192819 25.3005 0.639292C25.2639 1.2593 26.5845 2.36791 28.308 2.70312"
      :fill="props.fill"
    />
    <path
      d="M25.4511 5.9887C25.4942 7.26879 27.1884 8.53079 29.1768 8.58594C31.1652 8.64109 32.5617 7.45019 32.3368 6.13692C32.1118 4.82365 30.4672 3.95288 28.6529 3.92315C26.8385 3.89342 25.4081 4.70861 25.4511 5.9887Z"
      :fill="props.fill"
    />
    <path
      d="M29.2677 10.0528C29.1595 10.0399 29.0505 10.0347 28.9415 10.0373C27.0875 10.0558 25.5989 11.572 25.6144 13.426C25.6915 15.5445 27.4012 17.2387 29.5206 17.296C29.6335 17.302 29.7468 17.302 29.8597 17.296H29.8635C31.7572 17.1848 33.2036 15.5618 33.0972 13.6677C32.9446 11.656 31.2871 10.0903 29.2698 10.0532"
      :fill="props.fill"
    />
    <path
      d="M29.5488 19.1025C27.3966 19.0444 25.6051 20.742 25.5473 22.8941C25.4892 25.0463 27.1868 26.8378 29.3389 26.8955C31.4907 26.9537 33.2822 25.2565 33.3404 23.1048V23.0721V23.0449C33.3809 20.9096 31.6841 19.1452 29.5488 19.1025Z"
      :fill="props.fill"
    />
    <path
      d="M29.5236 28.8618C27.4064 28.9191 25.6976 30.6111 25.6191 32.7279C25.6191 32.8395 25.6239 32.9503 25.6342 33.0601V33.0632C25.7954 34.9034 27.418 36.2645 29.2582 36.1033H29.272C31.2889 36.0663 32.9464 34.5001 33.0976 32.4884C33.1041 32.3755 33.1041 32.2622 33.0976 32.1493C33.0201 30.2578 31.4241 28.7873 29.5327 28.8648H29.5249"
      :fill="props.fill"
    />
    <path
      d="M29.1768 37.5695C27.1896 37.6237 25.5015 38.887 25.4524 40.1684C25.4033 41.4498 26.8441 42.2577 28.6528 42.2322C30.4616 42.2068 32.1101 41.3274 32.3371 40.0168C32.5642 38.7061 31.1639 37.513 29.1768 37.5677"
      :fill="props.fill"
    />
    <path
      d="M28.306 43.4483C26.5826 43.793 25.2616 44.8925 25.2986 45.5139C25.3357 46.1351 26.4839 46.0567 27.9402 45.7892C29.3965 45.5216 30.8701 45.1209 31.0928 44.4263C31.3156 43.7318 30.0295 43.104 28.306 43.4483Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: '2.875rem'
  },
  height: {
    type: [Number, String],
    default: '2.875rem'
  },
  fill: {
    type: String,
    default: '#E7E6E5'
  }
})
</script>
